var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeakerphoneOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14556_52531)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.9996,
    height: 22.999,
    transform: "translate(0 0.00195312)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6662 6.40362V17.5353C10.666 17.8807 10.5439 18.2149 10.3214 18.4791C10.0989 18.7432 9.79026 18.9204 9.44994 18.9794C9.10962 19.0383 8.75941 18.9753 8.46101 18.8014C8.1626 18.6275 7.93515 18.3538 7.81873 18.0286L6.02957 12.9036M6.02957 12.9036C5.32225 12.6029 4.74055 12.0678 4.38292 11.3875C4.0253 10.7072 3.9137 9.92419 4.06701 9.17104C4.22033 8.41788 4.62914 7.74083 5.22428 7.25445C5.81941 6.76808 6.5643 6.50225 7.3329 6.50195H8.85957C12.2762 6.50195 15.2137 5.47362 16.4996 4.00195V15.6686C15.2137 14.197 12.2771 13.1686 8.85957 13.1686H7.3329C6.88509 13.1693 6.44178 13.0786 6.02957 12.9036ZM16.4996 12.3353C17.1626 12.3353 17.7985 12.0719 18.2673 11.6031C18.7362 11.1342 18.9996 10.4983 18.9996 9.83529C18.9996 9.17225 18.7362 8.53636 18.2673 8.06752C17.7985 7.59868 17.1626 7.33529 16.4996 7.33529",
    stroke: "#0E2C66",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 4.00195,
    r: 3,
    fill: "#FF5449",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14556_52531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.9996,
    height: 22.999,
    fill: "white",
    transform: "translate(0 0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerphoneOutline);
export default __webpack_public_path__ + "static/media/speakerphone_outline.b0aeae88bc0b7ab5d3e6c8889c651280.svg";
export { ForwardRef as ReactComponent };